import Mustache from 'mustache'
import { z } from 'zod'

import type { ViewQueryRecordNode } from '../../../schemas/query/index.ts'
import type { DynamicSelectOptionConfig } from '../../../schemas/ui/sheet.ts'

export async function getDynamicSelectOptions({
  config,
  recordNode,
  fetch,
}: {
  config: DynamicSelectOptionConfig
  recordNode: ViewQueryRecordNode | undefined
  fetch: (sql: string) => Promise<unknown[]>
}): Promise<Array<{ value: string; label: string }>> {
  // NOTE: configは今後unionにして、場合分けする予定
  const compiledSql = Mustache.render(config.sql, {
    record: recordNode,
  })
  const rows = await fetch(compiledSql)
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-type-assertion
  const row = rows[0] as any
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
  const values = row?.[config.valuesColumn]
  // stringのみを許可でいいだろうか？
  const stringValues = z.string().array().safeParse(values)
  if (stringValues.success) {
    return stringValues.data.map((value) => ({
      value,
      label: value,
    }))
  }
  // eslint-disable-next-line sonarjs/todo-tag
  // TODO
  return []
}
